import { z } from 'zod'

/**
 * FO-038 (batch-16) — voorkeurstelefoon (Facilities-blok op de medewerker) als
 * beheerbare keuzelijst i.p.v. vrij veld, zodat bestellingen/voorraad
 * (SIM/toestel) op een vaste set aansluiten. Gedeeld request-schema zodat de
 * API en de beheer-modal dezelfde validatie gebruiken (CLAUDE.md). Spiegelt het
 * TankpasLeverancier-patroon.
 */

/** Een voorkeurstelefoon-optie uit de beheerbare lijst. */
export interface VoorkeurTelefoonOptieDTO {
  id: string
  naam: string
  volgorde: number
  actief: boolean
}

export const CreateVoorkeurTelefoonOptieSchema = z.object({
  naam: z.string().trim().min(1, 'Naam is verplicht').max(100),
  volgorde: z.number().int().min(0).max(9999).optional(),
})
export type CreateVoorkeurTelefoonOptieInput = z.infer<typeof CreateVoorkeurTelefoonOptieSchema>

export const UpdateVoorkeurTelefoonOptieSchema = z
  .object({
    naam: z.string().trim().min(1, 'Naam is verplicht').max(100).optional(),
    volgorde: z.number().int().min(0).max(9999).optional(),
    actief: z.boolean().optional(),
  })
  .refine((v) => v.naam !== undefined || v.volgorde !== undefined || v.actief !== undefined, {
    message: 'Geef minstens één veld om bij te werken',
  })
export type UpdateVoorkeurTelefoonOptieInput = z.infer<typeof UpdateVoorkeurTelefoonOptieSchema>
